// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AjV_","left":"styles_left__3E687"};